import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch } from '../modules/utility';

const apiBase = 'companyDepartment';
const listName = `${apiBase}s`;
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;

const displayWord = 'department';
const onSuccessRedirectTo = `/administration`;

const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

const get = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : idsField,
			params,
			dispatch,
			successMessage : `New ${displayWord} was created successfully. 
				Click continue to return to the ${displayWord}s page.`,
			onSuccessRedirectTo,
			callback,
		});
	};
};

const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage : `${_.capitalize(displayWord)} updated successfully. 
				Click continue to return to the ${displayWord}s page.`,
			onSuccessRedirectTo,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	const newState = {};

	newState[listName] = [];
	if (state.lists[idsField]) {
		newState[listName] = _.map(state.lists[idsField], id => state.maps[apiBase][id]);
	}
	return newState;
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getCompanyDepartment : get,
	addCompanyDepartment : add,
	updateCompanyDepartment : update,
	searchCompanyDepartments : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);